var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorelist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.308 12C10.308 11.44 10.5 10.968 10.884 10.584C11.268 10.2 11.74 10.008 12.3 10.008C12.86 10.008 13.332 10.2 13.716 10.584C14.1 10.968 14.292 11.44 14.292 12C14.292 12.56 14.1 13.032 13.716 13.416C13.332 13.8 12.86 13.992 12.3 13.992C11.74 13.992 11.268 13.8 10.884 13.416C10.5 13.032 10.308 12.56 10.308 12ZM17.292 12C17.292 11.44 17.484 10.968 17.868 10.584C18.268 10.2 18.74 10.008 19.284 10.008C19.844 10.008 20.316 10.2 20.7 10.584C21.1 10.968 21.3 11.44 21.3 12C21.3 12.56 21.1 13.032 20.7 13.416C20.316 13.8 19.844 13.992 19.284 13.992C18.74 13.992 18.268 13.8 17.868 13.416C17.484 13.032 17.292 12.56 17.292 12ZM3.3 12C3.3 11.44 3.492 10.968 3.876 10.584C4.276 10.2 4.748 10.008 5.292 10.008C5.852 10.008 6.324 10.2 6.708 10.584C7.108 10.968 7.308 11.44 7.308 12C7.308 12.56 7.108 13.032 6.708 13.416C6.324 13.8 5.852 13.992 5.292 13.992C4.748 13.992 4.276 13.8 3.876 13.416C3.492 13.032 3.3 12.56 3.3 12Z",
    fill: "#2E3E46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorelist);
export default __webpack_public_path__ + "static/media/morelist.8b6f39f4.svg";
export { ForwardRef as ReactComponent };